import { render, staticRenderFns } from "./TaxonomyPortraits.vue?vue&type=template&id=3b1b46fd&"
import script from "./TaxonomyPortraits.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyPortraits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports